
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BTicketGuests',

  components: {
    IconUser: () => import('@white-label-icon/icon-user'),
  },

  props: {
    subItems: {
      type: Array,
      default() {
        return [];
      },
    },
    isExtras: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    filteredSubItemsList() {
      const deprecatedItems = ['children_ages']
      return this.subItems.filter((item) => {
      const titleLower = item?.title?.toLowerCase() || '';
      return !deprecatedItems.some(deprecated => titleLower.includes(deprecated));
    });
    }
  },
});
